<div class="text-viewer">
  <div class="status" *ngIf="loading">
    <i class="fa-solid fa-spinner fa-spin"></i>
    <span>Cargando...</span>
  </div>
  <div class="status error" *ngIf="error">{{ error }}</div>
  <div class="truncated-warning" *ngIf="truncated">
    <i class="fa-solid fa-triangle-exclamation"></i>
    Archivo muy grande; mostrando solo el inicio (500,000 caracteres).
  </div>
  <pre *ngIf="!loading && !error">{{ text }}</pre>
</div>
